module.exports = __webpack_public_path__ + "img/ic-send-mail.ea7192d9.svg";